(function () {
    console.log('CUSTOM COLLECTION --->');

    _sortSizeButtonsInGrid();
    function _sortSizeButtonsInGrid() {
      const my_card_hover = document.querySelectorAll('.type-product-grid-item');
      // console.log('my_card_hover', my_card_hover);
      my_card_hover.forEach((el, i) => {
          // console.log(el);
          el.addEventListener("mouseover", function( event ) {
              const my_size = event.currentTarget.querySelectorAll('.single-size-number');
              

              const SIZE_MAP = [
                  "J2XS",
                  "JXXS",
                  "JXS",
                  "JS",
                  "JM",
                  "JL",
                  "JXL",
                  "JXXL",
                  "J2XL",
                  "JXXXL",
                  "J3XL",
                  "JXS/S",
                  "JXS-S",
                  "JS/M",
                  "JS-M",
                  "JM/L",
                  "JM-L",
                  "JL/XL",
                  "JL-XL",
                  "JXL/XXL",
                  "JXL-XXL",
                  "JXXL/XXXL",
                  "JXXL-XXXL",
                  "JML",
                  "JSM",
                  "3XS",
                  "2XS",
                  "XXS",
                  "XS",
                  "S",
                  "M",
                  "L",
                  "XL",
                  "XXL",
                  "2XL",
                  "XXXL",
                  "3XL",
                  "XS/S",
                  "XS-S",
                  "S/M",
                  "S-M",
                  "M/L",
                  "M-L",
                  "L/XL",
                  "L-XL",
                  "XL/XXL",
                  "XL-XXL",
                  "XXL/XXXL",
                  "XXL-XXXL",
                  "ML",
                  "SM",
                  "MID",
                  "4XS",
                  "LOW",
                  "S-L",
                  "LXXL",
                  "53MM",
                  "52MM",
                  "54MM",
                  "55MM",
                  "56MM",
                  "51MM",
                  "50MM",
                  "57MM",
                  "60MM",
                  "58MM",
                  "2XXS",
                  "XL2L"
                ];
              
                var myVariants = new Array(SIZE_MAP.length);
              
              //   const my_size = document.querySelectorAll(".product-variant-picker-block .custom-input");
                // console.log('my_size', my_size);
              
                /*
                      console.log('beks1', $list[0]);
                      console.log('beks2', $($list[0]));
                      console.log('beks3', $($list[0]).data("gift-card"));*/
              
                if (
                  my_size && my_size[0] && my_size[0].textContent.toString().match(SIZE_MAP.join("|"))
                ) {
                  /* console.log('SIZE_MAP CASE --->'); */
                    my_size.forEach((el, i) => {
                    let $textContent = el.textContent;
                        myVariants[_.indexOf(SIZE_MAP, $textContent)] = $textContent;
                    });
                
                    myVariants = _.compact(myVariants);
                
                    my_size.forEach((el, i) => {
                      /* console.log('el', el); */
                        let $el = el;
                        $el.style.order = _.indexOf(myVariants, $el.textContent) + 1;
                    });
                } else {
                  let numericals = [];
              
                  my_size.forEach((el, i) => {
                    /* console.log('el', el); */
                    let $el = el;
                    let val = $el.textContent.toString();
              
                    if (val.match(/\s(?=[1-9]\/)/)) {
                        /* console.log('A'); */
                      /*
                                      7 1/4
                                  */
                      val = eval(val.replace(" ", "+"));
                    } else {
                        /* console.log('B'); */
                      /*
                                      3 anni
                                      3s
                                      13_5C
                                      7Y
                                      12-13.5
                                  */
                      val = parseFloat(val.replace(/(_|,)/g, ".").replace(/[^\d.]/g, ""));
                    }
              
                    if (isNaN(val)) {
                      val = 0;
                    }
              
                    numericals.push({
                      val: val,
                      i: i,
                    });
                  });
              
                  /* console.log('numericals', numericals); */
                  let numericals2 = [...numericals].sort(function (a, b) {
                    return a.val - b.val;
                  });
              
                  /* console.log('numericals2', numericals2); */
                  for (var i = 0; i < numericals2.length; i++) {
                    my_size[numericals2[i].i].style.order = i;
                  }
              }
          });
      });
    }

    const targetNode = document.getElementById('CollectionProductGrid');
    const targetNode2 = document.querySelector('.product-recommendations');
    /* console.log('targetNode', targetNode);
    console.log('targetNode2', targetNode2); */
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: false };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
    /* console.log(mutationsList, observer); */
      _sortSizeButtonsInGrid();
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    if (targetNode) observer.observe(targetNode, config);
    if (targetNode2) observer.observe(targetNode2, config);
})();